/* (ASYNC) */
export const FETCH_ALL_CATEGORIES_INIT = 'FETCH_ALL_CATEGORIES_INIT';
export const FETCH_ALL_CATEGORIES_SUCCESS = 'FETCH_ALL_CATEGORIES_SUCCESS';
export const FETCH_ALL_CATEGORIES_FAILURE = 'FETCH_ALL_CATEGORIES_FAILURE';

export const FETCH_ALL_TAGS_BY_CATEGORY_INIT = 'FETCH_ALL_TAGS_BY_CATEGORY_INIT';
export const FETCH_ALL_TAGS_BY_CATEGORY_SUCCESS = 'FETCH_ALL_TAGS_BY_CATEGORY_SUCCESS';
export const FETCH_ALL_TAGS_BY_CATEGORY_FAILURE = 'FETCH_ALL_TAGS_BY_CATEGORY_FAILURE';
export const ACCOUNT_TAG_RESET_CATEGORY_TAGS = 'ACCOUNT_TAG_RESET_CATEGORY_TAGS';

export const ACCOUNT_TAG_ADD_NEW_TAG_TO_SAVE_OR_DELETE = 'ACCOUNT_TAG_ADD_NEW_TAG_TO_SAVE_OR_DELETE';
export const ACCOUNT_TAG_REMOVE_NEW_TAG_TO_SAVE_OR_DELETE = 'ACCOUNT_TAG_REMOVE_NEW_TAG_TO_SAVE_OR_DELETE';
export const ACCOUNT_TAG_SAVE_TAGS_CHANGES_INIT = 'ACCOUNT_TAG_SAVE_TAGS_CHANGES_INIT';
export const ACCOUNT_TAG_SAVE_TAGS_CHANGES_SUCCESS = 'ACCOUNT_TAG_SAVE_TAGS_CHANGES_SUCCESS';
export const ACCOUNT_TAG_SAVE_TAGS_CHANGES_FAILURE = 'ACCOUNT_TAG_SAVE_TAGS_CHANGES_FAILURE';

export const RESET_ACCOUNT_TAG = 'RESET_ACCOUNT_TAG';



// WEBPACK FOOTER //
// ./source/client/actions/account_tag/types.js